import { NEXT_ACTION_SEVERITY } from '../PathToSubmission.constants';

// Each severity maps to a theme status variant so the tint + border flip with the
// palette (light: pale extraSoft/soft fill; dark: the variant's translucent tokens).
const SEVERITY_VARIANT = {
  [NEXT_ACTION_SEVERITY.BLOCKING]: 'error',
  [NEXT_ACTION_SEVERITY.IN_PROGRESS]: 'warning',
  [NEXT_ACTION_SEVERITY.READY]: 'success',
};

const CALLOUT_TITLE_COLOR = {
  [NEXT_ACTION_SEVERITY.BLOCKING]: 'error.main',
  [NEXT_ACTION_SEVERITY.IN_PROGRESS]: 'warning.main',
  [NEXT_ACTION_SEVERITY.READY]: 'success.main',
};

export const getCalloutStyles = severity => {
  const variant = SEVERITY_VARIANT[severity];

  return {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    padding: '12px 16px',
    borderRadius: '8px',
    backgroundColor: ({ palette }) => palette[variant].extraSoft,
    border: ({ palette }) => `1px solid ${palette[variant].soft}`,
  };
};

export const iconColumnStyles = {
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
};

export const textColumnStyles = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
};

export const getTitleStyles = severity => ({
  color: CALLOUT_TITLE_COLOR[severity],
});

export const actionsRowStyles = {
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};
